import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Footer from '../Footer';

class AboutUsPage extends Component<{},{}>{

    constructor(props: any){
        super(props);
          this.state = {
              
          };
      }

      render(){
          return (
              <div id="about-us">
                <header>
                    <ul>
                        <li><Link to="/Home">Home</Link></li>
                        <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                        <li><Link className="selected" to="/AboutUs">About Us</Link></li>
                        <li><Link to="/SummerDash">Summer Dash</Link></li>
                    </ul>
                </header>
                <body>
                    <div className="section"> 
                        About Us 
                        <p>Emmaniii Studios is a team of three young developers.<br/>All three of us are students who have interest in ethier game, music, or art design.</p>
                        <ul id="aboutus">
                            <li> <a href="https://www.instagram.com/iman_tanumihardja/">
                                    Iman Tanumihardja<br/>
                                    <div>(Game)</div>
                                </a> 
                            </li>
                            <li> <a href="https://www.instagram.com/hexnry/">
                                    Henry Tan<br/>
                                    <div>(Art)</div>
                                </a> 
                            </li>
                            <li> 
                                <a href="https://www.youtube.com/channel/UCV0o3jG4gR-Was7tq3ojbuw">
                                    Gabe Tanumihardja<br/>
                                    <div>(Music)</div>
                                </a> 
                            </li>
                        </ul>
                    </div>
                </body>
                <Footer></Footer>
              </div>
          )
      }
}

export default AboutUsPage;